module.exports = __webpack_public_path__ + "img/risk.ac08fe06.png";